import styled from 'styled-components'

export const FlexContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
`

FlexContainer.displayName = 'FlexContainer'

export const PageContent = styled.div`
  margin: 2rem 1rem;
  flex: 1 1 auto;
  display: flex;
`

PageContent.displayName = 'PageContent'

export const CenteredPageContent = styled(PageContent)`
  flex-direction: column;
  align-items: center;
`
CenteredPageContent.displayName = 'CenteredPageContent'

export const LeftAlignedPageContent = styled(PageContent)`
  flex-direction: column;
  align-items: start;
`

LeftAlignedPageContent.displayName = 'LeftAlignedPageContent'

export const FullPageCenteredPageContent = styled(CenteredPageContent)`
  justify-content: center;
`
FullPageCenteredPageContent.displayName = 'FullPageCenteredPageContent'
